<div class="th-menulevel">
  <div class="ir-btn ir-btn--big" [permissions]="[['visible', 'inspection.offline.menu', inspection]]"
    [ngClass]="isVisible('general') ? 'th-btn-action' : 'th-btn-menulevel'" (click)="showGroup($event, 'general')">
    <i *ngIf="isVisible('general')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.general' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [ngClass]="isVisible('edit') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'edit')">
    <i *ngIf="isVisible('edit')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.edit' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
    [ngClass]="isVisible('modules') ? 'th-btn-action' : 'th-btn-menulevel'" (click)="showGroup($event, 'modules')">
    <i *ngIf="isVisible('modules')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.modules' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
    [ngClass]="isVisible('plugins') ? 'th-btn-action' : 'th-btn-menulevel'" (click)="showGroup($event, 'plugins')">
    <i *ngIf="isVisible('plugins')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.plugins' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
    [ngClass]="isVisible('parts') ? 'th-btn-action' : 'th-btn-menulevel'" (click)="showGroup($event, 'parts')">
    <i *ngIf="isVisible('parts')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.parts' | translate }}</span>
  </div>
  <div class="th-menulevel--area">
    <div class="th-menulevel--areacontent">
      <div *ngIf="isVisible('general')" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.Information)">
        <span>{{ 'menus.information' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.Properties)">
        <span>{{ 'menus.properties' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && (isOptimization || isMaintenance) && hasActionPlan && onlyOnline"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.OpenActionPlan)">
        <span>{{ 'menus.open-action-plan' | translate }}</span>
      </div>
      <!-- <div
        *ngIf="isVisible('general') && isMaintenance && onlyOnline"
        class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.OpenMachines)"
      >
        <span>{{ 'menus.open-machines' | translate }}</span>
      </div> -->
      <div *ngIf="isVisible('general') && onlyOnline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.ChangeInputLanguage)">
        <span>{{ 'menus.inputLanguage' | translate }}</span>
      </div>
      <ng-container *ngIf="isVisible('parts') && isMaintenance && onlyOnline">
        <ng-container *ngIf="checkSapPrices$ | async as checkSapPrices">
          <div *ngIf="checkSapPrices.available"
            class="ir-btn ir-btn--area th-btn-menusublevel ir-inputfile" (click)="selectMenu(menus.ManageParts)">
            <span>{{ 'menus.manage-parts' | translate }}</span>
        </div>
        </ng-container>
      </ng-container>
      <div *ngIf="isVisible('parts') && isMaintenance && onlyOnline"
        class="ir-btn ir-btn--area th-btn-menusublevel ir-inputfile" (click)="selectMenu(menus.ImportParts)">
        <span>{{ 'menus.import' | translate }} {{ 'menus.parts' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.DownloadReport)">
        <span>{{ 'menus.download' | translate }} {{ 'menus.report' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.ReportList)">
        <span>{{ 'menus.reports' | translate }}</span>
      </div>
      <!-- <div *ngIf="isVisible('general')" [permissions]="[['visible', 'inspection.collaborate',inspection]]" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.Collaborate)">
        <span>{{ 'menus.collaborate' | translate  }}</span>
      </div> -->
      <div [permissions]="[['visible', 'inspection.delete', inspection]]" *ngIf="isVisible('general') && onlyOnline"
        class="ir-btn ir-btn--area th-btn-remove" (click)="selectMenu(menus.Delete)">
        <span>{{ 'menus.delete-inspection' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" [permissions]="[['visible', 'actions.restore', inspection]]"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.TrashCan)">
        <span>{{ 'menus.trash-can' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline && currentPerson.isHost"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.EditJson)">
        <span>{{ 'menus.edit-json' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" [permissions]="[['visible', 'manage.template']]"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.DownloadTranslation)">
        <span>{{ 'menus.export-data-translations' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" [permissions]="[['visible', 'manage.template']]"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.Status)">
        <span>{{ 'common.status' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.ImportModule)">
        <span>{{ 'menus.import' | translate }} {{ 'menus.module' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.CreateModule)">
        <span>{{ 'menus.create' | translate }} {{ 'menus.module' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.OrderModules)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.modules' | translate }}</span>
      </div>
      <div [permissions]="[['visible', 'inspection.add-plugin', inspection]]" *ngIf="isVisible('plugins')"
        class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(menus.AddPlugin)">
        <span>{{ 'menus.add' | translate }} {{ 'menus.plugin' | translate }}</span>
      </div>
      <div *ngIf="isVisible('plugins')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.OrderPlugins)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.plugins' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && onlyOnline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.AvailableOffline)">
        <span>{{ 'menus.offline.available-offline' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && isConnection && isInOffline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.RemoveFromOffline)">
        <span>{{ 'menus.offline.remove-offline' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general') && isConnection && isInOffline" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(menus.Synchronize)">
        <span>{{ 'menus.offline.synchronize' | translate }}</span>
      </div>
      <div *ngIf="isVisible('edit')" class="ir-btn ir-btn--area th-btn-{{ anyModules ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(menus.CopySelectedModules)">
        <span>{{ 'menus.copy' | translate }}</span>
      </div>
      <div *ngIf="isVisible('edit')" class="ir-btn ir-btn--area th-btn-{{ anyModules ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(menus.CutSelectedModules)">
        <span>{{ 'menus.cut' | translate }}</span>
      </div>
      <div *ngIf="isVisible('edit')" class="ir-btn ir-btn--area th-btn-{{ isPaste() ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(menus.PastModules)">
        <span>{{ 'menus.paste' | translate }}</span>
      </div>
      <div *ngIf="isVisible('edit') && !isInOffline"
        class="ir-btn ir-btn--area th-btn-{{ anyModules ? 'remove' : 'disabled' }}"
        (click)="selectMenu(menus.DeleteSelectedModules)">
        <span>{{ 'menus.delete-modules' | translate }}</span>
      </div>
    </div>
  </div>
</div>
